/*
 * EasyBarn — shared zoom/lightbox for door calculators
 * Hooks any [data-ebcd-zoom-url] click anywhere on the page
 * and opens a fullscreen image overlay. Self-contained, no deps.
 */
(function () {
  'use strict';

  if (window.__ebcdZoomInstalled) return;
  window.__ebcdZoomInstalled = true;

  var lb = null;
  var lbImg = null;
  var lbCaption = null;
  var savedOverflow = '';

  function ensureLightbox() {
    if (lb) return lb;
    lb = document.createElement('div');
    lb.className = 'ebcd-lightbox';
    lb.setAttribute('hidden', '');
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Door image');
    lb.innerHTML =
      '<button type="button" class="ebcd-lightbox-close" aria-label="Close">×</button>' +
      '<div class="ebcd-lightbox-inner">' +
        '<img class="ebcd-lightbox-img" alt="" />' +
        '<div class="ebcd-lightbox-caption"></div>' +
      '</div>';
    document.body.appendChild(lb);
    lbImg = lb.querySelector('.ebcd-lightbox-img');
    lbCaption = lb.querySelector('.ebcd-lightbox-caption');

    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.classList.contains('ebcd-lightbox-close')) {
        close();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !lb.hasAttribute('hidden')) close();
    });

    return lb;
  }

  function open(url, caption) {
    if (!url) return;
    var el = ensureLightbox();
    lbImg.src = url;
    lbImg.alt = caption || '';
    lbCaption.textContent = caption || '';
    el.removeAttribute('hidden');
    savedOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    var closeBtn = el.querySelector('.ebcd-lightbox-close');
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    if (!lb) return;
    lb.setAttribute('hidden', '');
    document.body.style.overflow = savedOverflow;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-ebcd-zoom-url]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    open(
      btn.getAttribute('data-ebcd-zoom-url'),
      btn.getAttribute('data-ebcd-zoom-caption') || ''
    );
  });
})();
